
import Input from "../../../components/input";
import Select from "../../../components/select";
import TextArea from "../../../components/textArea";
import { useCampaignCategories } from "../../reuseableEffects";

const CreateCampaignDetails = (
  {
    campaignTitleName, campaignTitleValue, campaignTitleOnChange,campaignTitleOnBlur,campaignTitleOnError, 
    campaignGoalName, campaignGoalValue, campaignGoalOnChange, campaignGoalOnBlur, campaignGoalOnError,
    categoryName, onCategoryChange, selectedCategory, onCategoryBlur, onCategoryError,
    locationName, selectedLocation, onLocationChange, onLocationBlur, onLocationError,
    campaignStoryName, campaignStoryValue, campaignStoryOnChange, campaignStoryOnBlur, campaignStoryOnError,
  
  }) => {
 
 
      const campaignCategories = useCampaignCategories();

  const categories = campaignCategories.map(category => ({
    value: category.needy_category_id,
    name: category.category,
  }));


  const states = [
    { value: "abia", name: "Abia" },
    { value: "adamawa", name: "Adamawa" },
    { value: "akwa-ibom", name: "Akwa Ibom" },
    { value: "anambra", name: "Anambra" },
    { value: "bauchi", name: "Bauchi" },
    { value: "bayelsa", name: "Bayelsa" },
    { value: "benue", name: "Benue" },
    { value: "borno", name: "Borno" },
    { value: "cross-river", name: "Cross River" },
    { value: "delta", name: "Delta" },
    { value: "ebonyi", name: "Ebonyi" },
    { value: "edo", name: "Edo" },
    { value: "ekiti", name: "Ekiti" },
    { value: "enugu", name: "Enugu" },
    { value: "gombe", name: "Gombe" },
    { value: "imo", name: "Imo" },
    { value: "jigawa", name: "Jigawa" },
    { value: "kaduna", name: "Kaduna" },
    { value: "kano", name: "Kano" },
    { value: "katsina", name: "Katsina" },
    { value: "kebbi", name: "Kebbi" },
    { value: "kogi", name: "Kogi" },
    { value: "kwara", name: "Kwara" },
    { value: "lagos", name: "Lagos" },
    { value: "nasarawa", name: "Nasarawa" },
    { value: "niger", name: "Niger" },
    { value: "ogun", name: "Ogun" },
    { value: "ondo", name: "Ondo" },
    { value: "osun", name: "Osun" },
    { value: "oyo", name: "Oyo" },
    { value: "plateau", name: "Plateau" },
    { value: "rivers", name: "Rivers" },
    { value: "sokoto", name: "Sokoto" },
    { value: "taraba", name: "Taraba" },
    { value: "yobe", name: "Yobe" },
    { value: "zamfara", name: "Zamfara" },
    { value: "fct", name: "Federal Capital Territory (FCT)" },
  ];

  return (
    <div>
      {/* <Back /> */}
      <div className="grid mt-4 mb-8">
        <span className="font-semibold">Step 2 of 5</span>
        <span className="text-secondary text-sm">Campaign details</span>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div className="md:col-span-2">
          <Input
            label={"Campaign title"}
            placeholder={"e.g Donate to help me... "}
            name={campaignTitleName}
            value={campaignTitleValue}
            onChange={campaignTitleOnChange}
            onBlur={campaignTitleOnBlur}
            onError={campaignTitleOnError}
          />
        </div>
        <div className="">
          <Input
            label={"Campaign goal"}
            type={"number"}
            placeholder={"0.00 "} 
            name={campaignGoalName}
            value={campaignGoalValue}
            onChange={campaignGoalOnChange}
            onBlur={campaignGoalOnBlur}
            onError={campaignGoalOnError}
          />
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 my-4">
        <div>
          <Select
            label="Campaign category"
            placeholder={"Select a category"}
            name={categoryName}
            value={selectedCategory}
            onChange={onCategoryChange}
            onBlur={onCategoryBlur}
            onError={onCategoryError}
            options={categories}
          />
        </div>
        <div>
          <Select 
          label="Campaign location"
          placeholder={"Select your location"}
          name={locationName}
          value={selectedLocation}
          onChange={onLocationChange}
          onBlur={onLocationBlur}
          onError={onLocationError}
          options={states}
          />
        </div>
      </div>
      <div className="mb-8">
        <TextArea
          label={"Campaign story"}
          placeholder={"Describe your campaign"}
          rows={"6"}
          name={campaignStoryName}
          value={campaignStoryValue}
          onChange={campaignStoryOnChange}
          onBlur={campaignStoryOnBlur}
          onError={campaignStoryOnError}
        />
      </div>
    </div>
  );
};

export default CreateCampaignDetails;
